let paysafeGatewayService = ($window, externalScriptService, paysafeErrorService) => {

  const load = () => externalScriptService.load('https://hosted.paysafe.com/js/v1/latest/paysafe.min.js');

  const mount = gatewayDetails => {
    return setup(gatewayDetails)
      .then(instance => {
        return {
          createToken: () => {
            const options = {
              threeDS: {
                amount: parseInt($window.document.getElementById('totalPaymentAmount').innerText),
                currency: `${$window.config.currency}`,
                accountId: parseInt(`${$window.config.gateways.paysafe.accountId}`),
                useThreeDSecureVersion2: true
              },
              vault: {
                holderName: `${$window.document.getElementById('firstName').value} ${$window.document.getElementById('lastName').value}`
              }
            };
            return new Promise((resolve, reject) => {
              instance.tokenize(options, (instance, error, result) => {
                if (error) {
                  reject({ message: paysafeErrorService.formatError(error) });
                }

                resolve({ id: result ? result.token : undefined });
              });
            });
          },
          createAction: () => Promise.resolve(),
          createPaymentRequestbutton: () => Promise.resolve()
        };
      });
  };

  const setup = gatewayDetails => {
    const options = getOptions(gatewayDetails);

    return new Promise((resolve, reject) => {
      $window.paysafe.fields.setup(gatewayDetails.key, options, (instance, error) => {
        if (error && error !== 'true') {
          reject(error);
        }

        resolve(instance);
      });
    });
  };

  const getOptions = gatewayDetails => {
    return {
      environment: gatewayDetails.env,
      fields: {
        cardNumber: {
          selector: '#card-number',
          placeholder: 'Card Number'
        },
        expiryDate: {
          selector: '#card-expiry',
          placeholder: 'Expiry',
        },
        cvv: {
          selector: '#card-cvv',
          placeholder: 'CVV',
        }
      }
    };
  };

  return {
    load,
    mount
  };
};

paysafeGatewayService.$inject = [ '$window', 'externalScriptService', 'paysafeErrorService' ];

export default paysafeGatewayService;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/services/paysafe.gateway.service.js